import { Injectable, Type } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '@app-core/providers/token.service';
import { Observable } from 'rxjs';
import { UserPrincipalService } from '@app-core/providers/user-principal.service';
import { HomeComponent } from '@modules/home/pages/home/home.component';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private token: TokenService,
              private router: Router,
              private userPrincipal: UserPrincipalService) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const isTokenExists = !!this.token.authInfo && !!this.token.authInfo.access_token;

    if (!isTokenExists) {
      this.router.navigate(['/login']);
      return false;
    }

    if (this.userPrincipal.isAuthorised) {
      return true;
    }

    return this.userPrincipal.getUserInfo()
      .then(() => true)
      .catch(() => false);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkPermissions(this.getScopename(childRoute));
  }

  private getScopename(route: ActivatedRouteSnapshot): string {
    // From current route name
    if (route.data && route.data.scopeName) {
      return route.data.scopeName;
    }

    const _ultimateParent = this.getUltimateParent(route);

    if (_ultimateParent.routeConfig.data && _ultimateParent.routeConfig.data.scopeName) {
      return _ultimateParent.routeConfig.data.scopeName;
    }

    if (_ultimateParent.data && _ultimateParent.data.scopeName) {
      return _ultimateParent.data.scopeName;
    }

    return route.routeConfig.data.scopeName;
  }

  private getUltimateParent(route: ActivatedRouteSnapshot) {
    let _currentRoute = route;
    const checkParent = () => _currentRoute.parent.component &&
      (_currentRoute.parent.component as Type<any>).name !== 'HomeComponent';

    while (checkParent()) {
      _currentRoute = _currentRoute.parent;
    }

    return _currentRoute;
  }

  private checkPermissions(route: string): boolean {
    const hasAccess = this.userPrincipal.userAccess.findIndex(el => el.name === route) > -1;
    if (!hasAccess) {
      this.router.navigate(['/restricted']);
    }
    return hasAccess;
  }
}
